import { useQuery } from '@apollo/client'
import { ExpensablesStatusCountsDocument } from 'generated/resources/graphql'

import type { StatusCounts } from './useDataCollectionConfig'

interface UseExpensablesStatusCountsParams {
  employeeIds?: number[]
  groupId?: number
  includeGrouped?: boolean
  includeManualDrafts?: boolean
  from?: Date
  to?: Date
}

export const useExpensablesStatusCounts = ({
  employeeIds,
  groupId,
  includeGrouped,
  includeManualDrafts,
  from,
  to,
}: UseExpensablesStatusCountsParams): StatusCounts | undefined => {
  const { data } = useQuery(ExpensablesStatusCountsDocument, {
    variables: {
      employeeIds,
      groupIds: groupId ? [groupId] : undefined,
      includeGrouped,
      includeManualDrafts,
      from,
      to,
    },
    fetchPolicy: 'cache-and-network',
  })

  if (!data) {
    return undefined
  }

  return {
    draft: data.expenses.draftCount.totalCount ?? 0,
    pending: data.expenses.pendingCount.totalCount ?? 0,
    approved: data.expenses.approvedCount.totalCount ?? 0,
    paid: data.expenses.paidCount.totalCount ?? 0,
  }
}
